import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, FormControlLabel, Switch } from "@mui/material";
import useTranslation from "../hooks/traslation";
import { SUPPORTED_LANGUAGES } from "../constants/languages";
import type { PromotionalBannerTexts } from "../services/promotionalBanners";

interface PromotionalBannerDetailsModalProps {
  categoryDisplay: string;
  texts: PromotionalBannerTexts;
  status: boolean;
  isPrimary: boolean;
  open: boolean;
  selectedId: string;
  onClose: () => void;
}

export default function PromotionalBannerDetails({
  open,
  categoryDisplay,
  texts,
  status,
  isPrimary,
  selectedId,
  onClose,
}: PromotionalBannerDetailsModalProps) {
  const isViewMode = Boolean(selectedId);
  const translate = useTranslation();

  return (
    <Modal className="modal addCategory_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>
              {translate?.promotionalBanner?.bannerDetails ||
                "Promotional Banner Details"}
            </h2>
            <div className="btn-close" onClick={onClose}>
              <CloseIcon />
            </div>
          </div>

          <form className="form" action="">
            <div className="control_group">
              <label>
                {translate?.promotionalBanner?.category || "Category"}
              </label>
              <TextField
                placeholder="Category"
                fullWidth
                value={categoryDisplay}
                hiddenLabel
                disabled={isViewMode}
              />
            </div>
            {SUPPORTED_LANGUAGES.map(({ code, label }) => (
              <div key={code} className="control_group">
                <label>{translate?.promotionalBanner?.text || "Text"} ({label})</label>
                <TextField
                  placeholder={`Text (${label})`}
                  fullWidth
                  multiline
                  rows={3}
                  value={texts[code] ?? ""}
                  hiddenLabel
                  disabled={isViewMode}
                />
              </div>
            ))}
            <div className="control_group">
              <FormControlLabel
                control={<Switch checked={!!status} disabled={isViewMode} />}
                label={
                  translate?.promotionalBanner?.status ||
                  translate?.globals?.status ||
                  "Status"
                }
              />
            </div>
            <div className="control_group">
              <FormControlLabel
                control={<Switch checked={!!isPrimary} disabled={isViewMode} />}
                label={
                  translate?.promotionalBanner?.isPrimary || "Primary"
                }
              />
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
